import { render, staticRenderFns } from "./DetalheCliente.vue?vue&type=template&id=7a24bb8b&"
import script from "./DetalheCliente.vue?vue&type=script&lang=js&"
export * from "./DetalheCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports